import { useRouter } from "next/router";

import useFilters from "hooks/useFilters";
import { scrollToTop } from "utils/scrollPosition";

import PageNavigation from "components/PageNavigation";

const Pagination: React.FC<{ totalPages: number }> = ({ totalPages = 0 }) => {
  const { addDispensaryFilter } = useFilters();
  const { query } = useRouter();

  const page = parseInt(query.page ? String(query.page) : "1", 10);

  const handleUpdatePage = (newPage: number) => {
    addDispensaryFilter("page", String(newPage));
    setTimeout(scrollToTop, 100);
  };

  return totalPages > 1 ? (
    <PageNavigation
      currentPage={page}
      totalPages={totalPages}
      onNext={() => handleUpdatePage(page + 1)}
      onPrev={() => handleUpdatePage(page - 1)}
    />
  ) : null;
};

export default Pagination;
